import { z } from "zod";

// SPEC-218 §4: "Cuerpo. Bilingüe. Obligatorio" — el español siempre existe;
// el inglés es opcional (RN-24, ADR-007). El servidor vuelve a exigirlo
// (`isBilingual` en message-template.service.ts) si este esquema se
// saltea; este mensaje es el respaldo de cliente, no la fuente de verdad.
export const BODY_REQUIRED_MESSAGE = "El cuerpo es obligatorio";

// SPEC-218 §4: "Asunto ... Solo en plantillas de correo" también implica que,
// en una plantilla de correo, el asunto en español no puede quedar vacío
// (`isBilingual` del servidor lo rechaza, `message-template.service.ts`) —
// el esquema de abajo no lo distingue porque no conoce el canal de la
// plantilla; `TemplateEditor.submit` aplica esta regla a mano, igual que ya
// hace con `BODY_REQUIRED_MESSAGE`/`isEmptyRichText`.
export const SUBJECT_REQUIRED_MESSAGE =
  "El asunto es obligatorio para plantillas de correo";

// SPEC-218 §10: mismo literal que arma `sendMessageTemplateParameterMissing`
// (`api/src/infrastructure/http/problem.ts`) para el 400 `PARAMETER_MISSING`
// — compartido acá para que la validación previa del cliente
// (`TemplateEditor.submit`) y el mensaje que muestra el error real de la API
// (`MessageTemplatesScreen.tsx`, `parameterMissingMessage`) digan exactamente
// lo mismo.
export function parameterMissingMessage(parameter: string): string {
  return `El cuerpo debe incluir {${parameter}}. Sin él, el mensaje no sirve`;
}

// Zod no puede inspeccionar el HTML del editor (es una cadena, no texto
// plano): la vacuidad real se calcula con `isEmptyRichText` (RichTextEditor.tsx)
// antes de llamar a `safeParse`, mismo criterio que separar la validación de
// forma de la de contenido en `offerFormSchema`.
export const templateFormSchema = z.object({
  subjectEs: z.string(),
  subjectEn: z.string(),
  bodyEs: z.string().trim().min(1, BODY_REQUIRED_MESSAGE),
  bodyEn: z.string(),
  active: z.boolean(),
});
export type TemplateFormValues = z.infer<typeof templateFormSchema>;
